import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import RoleListCell from "./CustomCells/RoleList";
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-material.css';
import UserCellRenderer from "../UserManagement/DeleteUserModal/UserCellRenderer";

export interface TableComponentProps {
  data?: any;
  searchVal?: string;
  openModal?: Function;
  getFilteredData?: Function;
}

const TableComponent: React.FC<TableComponentProps> = ({ data, searchVal, openModal,getFilteredData }) => {

  const [columns, setColumns] = useState<any>([]);
  const [rows, setRows] = useState<any[]>([]);
  const [allRows, setAllRows] = useState<any[]>([]);
  const [original, setOriginal] = useState<any[]>([]);

  // filters table for when user types in search value
  useEffect(() => {
    if (searchVal && searchVal !== "") {
      let daraRows = [...allRows];
      let newRows = daraRows.filter((r: any) => JSON.stringify(r).toLowerCase().includes(searchVal.toLowerCase()));
      setRows(newRows);
    } else {
      setRows(original);
    }
  }, [searchVal]);

  let dateFilterParams = {
    comparator: function (filterLocalDateAtMidnight: any, cellValue: any) {
      var dateAsString = cellValue;
      if (dateAsString == null) return -1;
      var dateParts = dateAsString.split('/');
      var cellDate = new Date(
        Number(dateParts[2].includes(',') ? dateParts[2].split(',')[0] : dateParts[2].split(' ')[0]),
        Number(dateParts[0]) - 1,
        Number(dateParts[1])
      );
      if (filterLocalDateAtMidnight.getTime() === cellDate.getTime()) {
        return 0;
      }
      if (cellDate < filterLocalDateAtMidnight) {
        return -1;
      }
      if (cellDate > filterLocalDateAtMidnight) {
        return 1;
      }
      return 0;
    },
    minValidYear: 2000,
    maxValidYear: new Date().getFullYear()
  };

  // const roleValueFormatter = (props: any) => {
  //   let products = (props.value !== null && props.value.length > 0) ? props.value.map((p: any) => p.application) : [];
  //   let roles = (props.value !== null && props.value.length > 0) ? props.value.map((p: any) => p.roleName) : [];

  //   return products.length + ' applications, ' + roles.length + ' roles';
  // };

  // grabs data and sets columns and rows for mui data grid
  useEffect(() => {
    if (data && data.length > 0) {
      let flatData = data.map((item: any) => ({ ...item.data, ...item }));
      //console.log(flatData);
      if (flatData.metadata) {
        flatData = flatData.map((item: any) => ({ ...item.metadata, ...item }));
      }
      let keys = Object.keys(flatData[0]);

      let newRows = [];
      let newKeys = [];

      // rows
      for (let z = 0; z < flatData.length; z++) {
        let newRow = {
          ...flatData[z],
        }
        newRows.push(newRow);
      }

      // columns
      for (let i = 0; i < keys.length; i++) {
        let obj: any = null;

        if (keys[i] === "email") {
          obj = {
            field: keys[i], minWidth: 200,
            cellRendererSelector: (params: any) => {
              return { component: UserCellRenderer }
            },
            cellRendererParams: openModal ?
              {
                deleteAction: (modal: any, user: any) => openModal(modal, user),
                editAction: (modal: any, user: any) => openModal(modal, user)
              } :
              {}
          }
        }
        else if (keys[i] === "firstName") {
          obj = { headerName: 'First Name', field: keys[i] }
        }
        else if (keys[i] === "lastName") {
          obj = { headerName: 'Last Name', field: keys[i] }
        }
        else if (keys[i] === "phoneNumber") {
          obj = { headerName: 'Phone Number', field: keys[i] }
        }
        else if (keys[i] === "userStatus") {
          obj = { headerName: 'User Status', field: keys[i] }
        }
        else if (keys[i] === "creationDate") {
          obj = { headerName: 'Created Date', field: keys[i], filter: 'agDateColumnFilter', filterParams: dateFilterParams }
        }
        else if (keys[i] === "createdBy") {
          obj = { headerName: 'Created By', field: keys[i] }
        }
        else if (keys[i] === "lastUpdateDate") {
          obj = { headerName: 'Last Updated Date', field: keys[i], filter: 'agDateColumnFilter', filterParams: dateFilterParams }
        }
        else if (keys[i] === "lastUpdatedBy") {
          obj = { headerName: 'Last Updated By', field: keys[i] }
        }
        else if (keys[i] === "userRoleList") {
          obj = {
            headerName: 'User Role List',
            field: keys[i],
            cellRendererSelector: (params: any) => {
              return { component: RoleListCell }
            },
            filter:false
            // filter:'agSetColumnFilter',
            // filterParams: {
            //   valueFormatter: roleValueFormatter
            // }
          }
        }
        if (obj) {
          if (keys[i] === "email")
            newKeys.unshift(obj);
          else
            newKeys.push(obj);
        }
      }
      setColumns(newKeys);
      setRows(newRows);
      setOriginal(newRows);
      setAllRows(newRows);
    }
    else { // this values are shown when list is empty
      setRows([]);
      setOriginal([]);
      setColumns([
        { headerName: 'Email' },
        { headerName: 'First Name' },
        { headerName: 'Last Name' },
        { headerName: 'Phone Number' },
        { headerName: 'User Status' },
        { headerName: 'Created Date' },
        { headerName: 'Created By' },
        { headerName: 'Last Updated Date' },
        { headerName: 'Last Updated By' },
        { headerName: 'User Role List' },
      ]);
      setAllRows([]);
    }
  }, [data]);

  const defaultColDef = {
    sortable: true,
    filter: 'agSetColumnFilter',
    resizable: true
  };

   // Downloading Only Filtered Data After Search
   useEffect(() => {
    if (getFilteredData)
      getFilteredData(rows);
  },[rows]);

  return (
    <Box className="ag-theme-material" sx={{ height: "100%", width: '100%' }}>
      <AgGridReact
        defaultColDef={defaultColDef}
        rowData={rows}
        columnDefs={columns}
        pagination={true}
        paginationPageSize={100}
        suppressHorizontalScroll={false}
        suppressPreventDefaultOnMouseWheel={true}
        rowSelection={"single"}
        rowHeight={40}
        headerHeight={35}
        enableRangeSelection={true}
      >
      </AgGridReact>
    </Box>
  );
}

export default TableComponent;
